import React from 'react';
import { Box } from '@mui/material';

/**
 * Uma linha de cartões lado a lado, em CSS Grid.
 *
 * POR QUE NÃO O `Grid container` DO MUI: as telas empilham blocos dentro de um
 * `<Stack spacing={3}>`, e o Stack zera a margem de TODO filho direto — a regra
 * dele é literalmente `& > :not(style):not(style) { margin: 0 }`. O
 * `Grid container` do MUI v5 se dá `width: calc(100% + 24px)` e compensa isso
 * com `margin-left: -24px`. O Stack apagava a margem e deixava a largura: a
 * linha inteira nascia 24px mais larga que a coluna de conteúdo, os cartões
 * começavam 24px à direita dos blocos de cima e o último vazava 24px para fora
 * da coluna. Medido em Dados, Resultado e Planos — é o desalinhamento que se
 * enxerga a olho nu entre um cartão de bloco e a linha de cartões abaixo dele.
 *
 * CSS Grid resolve pelo `gap`: sem margem negativa, não há nada para o Stack
 * zerar, e a linha mede exatamente a largura da coluna.
 *
 * @param {number} colunas   Quantas colunas no desktop.
 * @param {number} minimo    Largura mínima de cada coluna, em px.
 * @param {'md'|'lg'} apartir  A partir de qual largura a linha divide em
 *   colunas. Cartão de conteúdo (um plano, um caminho) divide cedo, em `md`;
 *   bloco de leitura com texto corrido divide só em `lg`, senão a linha de
 *   texto fica curta demais no notebook.
 */
const Colunas = ({ colunas = 2, minimo = 240, apartir = 'md', children, sx }) => (
  <Box
    sx={{
      display: 'grid',
      gap: 3,
      gridTemplateColumns: {
        xs: '1fr',
        [apartir]: `repeat(${colunas}, minmax(${minimo}px, 1fr))`
      },
      // Cartões de uma mesma linha terminam na mesma altura. Sem isto, dois
      // planos lado a lado com listas de tamanhos diferentes fecham em alturas
      // diferentes, e o mais curto parece incompleto.
      alignItems: 'stretch',
      ...sx
    }}
  >
    {children}
  </Box>
);

export default Colunas;
